import { Typography } from '@mui/material';
import React from 'react'
import './spinner.css';
function Spinner() {
    return (
        <div style={{width:'100%', height:'100vh', display:'flex', flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
            <Typography variant="h3" sx={{textAlign:'center'}}>Kunal's Drycleaners</Typography>
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
    )
}       

export default Spinner